export enum EBPMSStatus {
    Good = 0,
    Warning = 1,
    Critical = 2,
    Unknown = 99
}